// Canonical, human-readable paths for flattened structured data.
// Simple keys retain the familiar dotted form (`db.host`). Keys containing
// structural delimiters are JSON-quoted (`["a.b"]`) so no two source shapes
// can collapse to the same flattened key.

export function appendPropertyPath(path, key) {
  const segment = String(key);
  const safe = segment.length > 0 && !/[.[\]"]/u.test(segment);
  if (safe) return path ? `${path}.${segment}` : segment;
  return `${path}[${JSON.stringify(segment)}]`;
}

export function leafPath(path) {
  const quoted = path.match(/\[("(?:\\.|[^"\\])*")\]$/u);
  if (quoted) {
    try {
      return JSON.parse(quoted[1]);
    } catch {
      // Fall through to the simple path parser for malformed external input.
    }
  }
  const simple = path.match(/([^.[\]]+)\]?$/u);
  return simple ? simple[1] : path;
}

export function isIgnoredPath(path, ignore) {
  return ignore.has(path) || ignore.has(leafPath(path));
}
